import * as Sentry from "@sentry/react";
import { getCurrentUser } from './auth';
import { API_PERMISOS, API_SDA } from "../utils/urls";

async function parseJsonResponse(response) {
    const contentType = response.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
        return null;
    }

    try {
        return await response.json();
    } catch (error) {
        return null;
    }
}

async function request(url, method, data, retry) {
    var token = await getCurrentUser();

    let response;
    try {
        response = await fetch(`${API_SDA}${url}`, {
            method: method,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token.token
            },
            body: data ? JSON.stringify(data) : undefined
        });
    } catch (error) {
        const networkError = new Error(`No fue posible conectar con el servicio (${method} ${url})`);
        Sentry.captureException(networkError, {
            extra: {
                endpoint: `${API_SDA}${url}`,
                method,
                retry,
            },
        });
        throw networkError;
    }

    if (method !== 'DELETE') {
        if (response.status === 503) {
            console.log(`Error 503, reintento ${retry}, url: ${response.url}`);
            if (retry < 3) {
                return request(url, method, data, retry + 1);
            } else {
                Sentry.captureMessage(`Error 503, reintento ${retry}, url: ${response.url}`);
                throw new Error(`Error 503, reintentos superados, url: ${response.url}`);
            }
        } else {
            const jsonResponse = await parseJsonResponse(response);
            if (response.status !== 200 && response.status !== 201 && response.status !== 204) {
                let error = new Error(`Error HTTP ${response.status} en ${method} ${url}`);
                if (jsonResponse && jsonResponse.errors) {
                    error = jsonResponse.errors;
                }
                throw error;
            }
            return jsonResponse;
        }
    }
}

async function requestArchivo(url, method, data) {
    var token = await getCurrentUser();
    var formData = new FormData();
    for (var name in data) {
        formData.append(name, data[name]);
    }

    const response = await fetch(`${API_SDA}${url}`, {
        method: method,
        headers: {
            Authorization: 'Bearer ' + token.token
        },
        body: formData ? formData : undefined
    });
    if (method !== 'DELETE') {
        const multipartResponse = await response.json();
        /*if(response.status !== 200 && response.status !== 201 && response.status !== 204){
            let error;
            if(jsonResponse && jsonResponse.errors){
                error = jsonResponse.errors[0].message
            }
            throw Error(error || "hubo un error")
        }*/
        return multipartResponse;
    }
}

async function dataUsuario(usuarioID) {
    var token = await getCurrentUser();
    const permisoURL = `${API_PERMISOS}/user/uid/${usuarioID}`;
    const plataformaID = process.env.REACT_APP_PLATAFORMA_ID || "6908ca32e22380042b6e0f4e";
    const response = await fetch(`${permisoURL}?plataforma=${plataformaID}&sdaPermisos=true`, {
        method: "GET",
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token.token
        }
    });
    const jsonResponse = await response.json();
    if (response.status !== 200 && response.status !== 201 && response.status !== 204) {
        let error;
        if (jsonResponse && jsonResponse.errors) {
            error = jsonResponse.errors;
        }
        throw error;
    }
    return jsonResponse;
}

export function crear(url, data) {
    return request(url, 'POST', data, 0);
}

export function modificar(url, id, data) {
    return request(`${url}/${id}`, 'PUT', data, 0);
}

export function leer(url, id) {
    if (id) return request(`${url}/${id}`, 'GET', null, 0);
    else return request(`${url}`, 'GET', null, 0);
}

export function borrar(url, id) {
    return request(`${url}/${id}`, 'DELETE', null, 0);
}

export function perfil(url, id, uid) {
    return request(`${url}/${id}/${uid}`, 'GET', null, 0);
}

export function solicitud(url, id, userId) {
    return request(`${url}/${id}?usuario=${userId}`, 'PUT', null, 0);
}

export function solicitarAprobacion(url, id) {
    return request(`${url}/${id}`, 'POST', null, 0);
}

export function crearArchivo(url, data) {
    return requestArchivo(url, 'POST', data);
}

export function obtenerInfoUsuario(usuarioID) {
    return dataUsuario(usuarioID);
}
